var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 58,
    viewBox: "0 0 90 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.2703 1H1.07206L1 48.3513L64.9279 48.2793L70.4775 52.2432L72.9279 50.5135L79.4865 50.7297L81.6487 52.3874L86.3333 54.2612L86.5495 55.991L89 56.6396L86.7658 52.9639L88.8559 46.9099L87.1982 44.6036L88.0631 42.6576L87.1261 41.072L88.6396 40.4955V11.018L84.8198 7.84682L84.2432 6.11709L87.2703 3.59457L87.2703 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSd);
export default __webpack_public_path__ + "static/media/SD.6a9f1eabff2adbe8ba9b20210cb7c10f.svg";
export { ForwardRef as ReactComponent };